angular.module('invoice')
    .factory('InvoiceCostCenter', function ($resource) {
        return $resource('/crm/api/invoice-cost-center/:id', {}, {
            list: {method: 'GET', isArray: false},
            get: {method: 'GET'},
            update: {method: 'PUT', params: {id: "@id"}},
            remove: {method: 'DELETE'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/invoice-cost-center/autocomplete'}
        })
    })
    .service('InvoiceCostCenterService', function ($rootScope, toastr, modals, InvoiceCostCenter) {
        this.edit = id => {
            return InvoiceCostCenter.get({id: id}, entity => editModal(entity))
        }
        this.addModal = () => {
            let entity = {
                id: null
            }
            return editModal(entity)
        };
        this.remove = item => {
            return modals.confirmDelete(item.name, () => InvoiceCostCenter.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('invoice-cost-center.updated')));
        }

        function editModal(entity) {
            return modals.open('app/invoice/cost-center/edit-modal.html', 'InvoiceCostCenterDialogController', entity, {size: "sm"}, "$ctrl");
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('invoiceCostCenterList', {
            parent: 'app',
            url: '/settings/invoice-cost-center?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_INVOICE_SETTINGS_READ']
            },
            views: {
                'content@': 'invoiceCostCenterList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (InvoiceCostCenter, $stateParams) => InvoiceCostCenter.list(angular.copy($stateParams)).$promise
            }
        })
    })
